import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setBreadCrumbs } from '../actions/breadcrumbs.js';
import { setActiveProposal } from '../actions/application.js';
import { fetchSessionsByProposal } from '../actions/sessions.js';
import ProposalTable from '../components/Proposal/ProposalTable.js';
import PropTypes from 'prop-types';


class ProposalsContainer extends Component {
  constructor(props) {
        super(props); 
        this.onProposalSelected = this.onProposalSelected.bind(this);                   
  }

  onProposalSelected(proposal, title){        
    this.props.setActiveProposal(proposal, title);    
    this.props.fetchSessionsByProposal(this.props.user, proposal)
  }

  render() {              
    if ((!this.props.user) || (!this.props.user.token)) {         
      return null;
    }
    
    return (
      <div>
        <ProposalTable handleSelect={this.onProposalSelected} proposals={this.props.proposals}></ProposalTable>
      </div>);
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    proposals : state.proposals    
  };
}

function mapDispatchToProps(dispatch) {
  return {  
    setBreadCrumbs: (breadCrumbs) => dispatch(setBreadCrumbs(breadCrumbs)),
    setActiveProposal: (proposal, title) => dispatch(setActiveProposal(proposal, title)),
    fetchSessionsByProposal: (user, proposal) => dispatch(fetchSessionsByProposal(user, proposal)),        
  };
}

ProposalsContainer.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProposalsContainer);










// WEBPACK FOOTER //
// ./src/containers/ProposalsContainer.js